import { flex, opacityEffect } from "../styles/utils";
import styled from "styled-components";

export const NavContainer = styled.nav`
  ${flex("row")}
  gap:10px;
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 10px;

  button {
    ${flex("column", "center")}
    ${opacityEffect}
    background: black;
    border-radius: 10px;
    border: none;
    color: white;
    font-size: 11px;
    gap: 5px;
    padding: 10px 5px;
    width: 33%;

    &.active {
      background: var(--yellow-500);
      color: black;
      font-weight: 700;

      img,
      svg {
        filter: initial;
      }
    }

    img,
    svg {
      filter: invert(100%);
    }
  }
`;
